// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`ReferidosEmprendedores test Match con el snapshot 1`] = `""`;
